/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import PropertiesPlugin from "./PropertiesPlugin";
import { TelemetryTrace } from "./Context/TelemetryTrace";
import { TelemetryContext } from "./TelemetryContext";
import { Session, _SessionManager } from "./Context/Session";
export { PropertiesPlugin, TelemetryTrace, TelemetryContext, Session, _SessionManager as SessionManager };
//# sourceMappingURL=applicationinsights-properties-js.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-properties-js/dist-esm/applicationinsights-properties-js.js
// module id = 126
// module chunks = 0